import { Box, Button, Stack, Typography } from "@mui/material"
import React, { Fragment } from "react"
import { GenericCircleIcon } from "../../../generic/GenericCircleIcon"
import { CheckCircle } from "@phosphor-icons/react"
import { NeedHelp } from "./GenericDialogFooter"
import { useTheme } from "@emotion/react"

export const GenericVerifiedContent = ({ handleOpenLoginDialog, label }) => {
  const theme = useTheme();

  return (
    <Fragment>
      <Box display={'flex'} justifyContent={'center'} alignItems={'center'} mb={2}>
        <GenericCircleIcon>
          <CheckCircle size={96} weight="thin" color={theme.palette.primary.main} />
        </GenericCircleIcon>
      </Box>
      <Stack gap={3} alignItems={'center'}>
        <Typography fontSize={'16px'} textAlign={'center'} fontWeight={600}>
          {label}
        </Typography>
        <Button onClick={() => handleOpenLoginDialog()} variant="contained" sx={{ color: "#FFF", width: { md: '250px' } }}>Login</Button>
        <NeedHelp />
      </Stack>
    </Fragment>
  )
}